import { sentryOptionsFromEnv } from '@synqo/cloud-client-shared';
import { APP_VERSION } from './runtimeConstants';

export const SENTRY_OPTIONS = sentryOptionsFromEnv(import.meta.env, APP_VERSION);
